import React from "react";
import ReactTyped from "react-typed";
import { Divider } from "antd";

const About = () => {
  return (
    <div>
      <section id="heading">
        <h2 style={{ marginTop: "10.5rem" }} className="text-center">
          Michael Akindiilete
        </h2>
        <p className="text-muted text-center">
          <i>
            <ReactTyped
              strings={[
                "Think, Believe, Work, Archive.",
                "Front-End Developer.",
                "Mobile App Developer.",
                "Graphics Designer.",
              ]}
              typeSpeed={40}
              loop
            />
          </i>
        </p>
        <br />
        <div className="row">
          <div className="col-md-4 d-flex flex-column justify-content-around">
            <p className="fw-bold">💻 Frontend Engineer</p>
            <p className="fw-bold">📱 Mobile App Engineer</p>
            <p className="fw-bold">🎨 Graphics Designer</p>
          </div>
          <div className="col-md-8">
            <p>
              I am accustomed to working with remote teams and keen on
              architecting scalable and critically thought-out solutions while
              focused on customer satisfaction.
            </p>
            <p>
              Over the past years of developer experience, I have worked in the
              finance, e-commerce, and hospitality industry of which I've
              accrued different problem-solving methodologies.
            </p>
          </div>
        </div>
        <Divider className="bg-light" />
      </section>
    </div>
  );
};

export default About;
